/**
 * Preferencias guardadas de la calculadora FIRE (perfil de usuario).
 * Los nombres coinciden con los campos internos de CalculadoraFire.
 */

export const FIRE_PREFS_KEYS = [
  'anoNacimiento',
  'patrimonioActual',
  'beneficioLatente',
  'aportacionMes',
  'retiroMensualPostFire',
  'rentabilidad',
  'inflacion',
  'gastoMes',
  'tasaRetiro',
  'retencionFiscal',
  'horizonte'
];

export const DEFAULT_FIRE_PREFS = {
  anoNacimiento: 1987,
  patrimonioActual: 433000,
  beneficioLatente: 30,
  aportacionMes: 2200,
  /** Retiro mensual nominal (€ de hoy) tras el FIRE; 0 = sin retiro por defecto. Crece con IPC como el gasto. */
  retiroMensualPostFire: 0,
  rentabilidad: 7.0,
  inflacion: 2.0,
  gastoMes: 2300,
  tasaRetiro: 3.5,
  retencionFiscal: 20.0,
  horizonte: 50
};

function clamp(n, min, max) {
  const x = Number(n);
  if (Number.isNaN(x)) return min;
  return Math.min(max, Math.max(min, x));
}

/** Normaliza objeto parcial guardado en BD → objeto seguro para la UI */
function resolveRetiroMensualPostFire(raw, merged) {
  if (Object.prototype.hasOwnProperty.call(raw, 'retiroMensualPostFire')) {
    return Number(raw.retiroMensualPostFire);
  }
  if (Object.prototype.hasOwnProperty.call(raw, 'retiroAnualPostFire')) {
    const ann = Number(raw.retiroAnualPostFire);
    if (Number.isNaN(ann) || ann <= 0) return 0;
    return Math.round(ann / 12);
  }
  return Number(merged.retiroMensualPostFire) || 0;
}

export function normalizeFirePrefs(raw) {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_FIRE_PREFS };
  const merged = { ...DEFAULT_FIRE_PREFS, ...raw };
  const retiroMensualPostFire = resolveRetiroMensualPostFire(raw, merged);
  return {
    anoNacimiento: clamp(merged.anoNacimiento, 1940, 2010),
    patrimonioActual: clamp(merged.patrimonioActual, 0, 50_000_000),
    beneficioLatente: clamp(merged.beneficioLatente, 0, 100),
    aportacionMes: clamp(merged.aportacionMes, 0, 50_000),
    retiroMensualPostFire: clamp(retiroMensualPostFire, 0, 30_000),
    rentabilidad: clamp(merged.rentabilidad, 0, 25),
    inflacion: clamp(merged.inflacion, 0, 15),
    gastoMes: clamp(merged.gastoMes, 0, 30_000),
    tasaRetiro: clamp(merged.tasaRetiro, 1, 10),
    retencionFiscal: clamp(merged.retencionFiscal, 0, 50),
    horizonte: clamp(merged.horizonte, 5, 80)
  };
}

/**
 * Objeto a persistir en perfil.
 * @param {object} form — valores del formulario de perfil
 * @param {boolean} esAdmin — si true, no se guarda patrimonioActual
 */
export function buildFirePrefsForSave(form, esAdmin) {
  const n = normalizeFirePrefs(form);
  if (esAdmin) {
    const { patrimonioActual: _p, ...rest } = n;
    return rest;
  }
  return n;
}
